import { render, staticRenderFns } from "./p4.vue?vue&type=template&id=6e64c19e&scoped=true&"
import script from "./p4.vue?vue&type=script&lang=js&"
export * from "./p4.vue?vue&type=script&lang=js&"
import style0 from "./p4.vue?vue&type=style&index=0&id=6e64c19e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e64c19e",
  null
  
)

export default component.exports